import {
  getSceneResponsiveLayout,
  type LogicalBounds,
  type ResponsiveLayoutConfig,
} from '../../../shared/layout/index.js';

export const STORY_FOREST_LAYOUT_WIDTH = 1280;
export const STORY_FOREST_LAYOUT_HEIGHT = 720;

export type StoryForestSafeBounds = LogicalBounds;

export interface StoryForestLayoutSnapshot {
  safe: StoryForestSafeBounds;
  compact: boolean;
}

const STORY_FOREST_RESPONSIVE_LAYOUT: ResponsiveLayoutConfig = {
  logicalSize: { width: STORY_FOREST_LAYOUT_WIDTH, height: STORY_FOREST_LAYOUT_HEIGHT },
  // Preserve the existing safe-coordinate contract while the scene keeps its
  // established FIT renderer configuration.
  visibilityScaleMode: 'envelop',
  safeInsets: { left: 12, right: 12 },
  compactViewportHeight: 700,
  compactVisibleHeight: 690,
  compactVisibleWidth: 1100,
};

// Compatibility adapter retained so Story Forest mechanics do not own shared
// bounds math and can migrate independently of renderer/art readiness.
export function resolveStoryForestLayout(scene: Phaser.Scene): StoryForestLayoutSnapshot {
  const { safe, compact } = getSceneResponsiveLayout(scene, STORY_FOREST_RESPONSIVE_LAYOUT);
  return {
    safe,
    compact,
  };
}
